import TandaEditor from "./tanda_editor"
import CollapsedConfigItem from "./collapsed_config_item"
import { pluralizeStepType } from "shared/lib/utils"

const StepConfig = ({
  step,
  availableTandas,
  alreadySelectedTandas,
  contextChannelId,
  errors,
  oneBasedIndex,
  onStepRemove,
  onUpdateField,
  onSelectStep,
  onChangeCollapse,
  published,
  refToScroll,
}) => {
  const saveAndClose = () => {
    onChangeCollapse(step.type, true)

    if (refToScroll.current) {
      refToScroll.current.scrollIntoView({ block: "center" })
    }
  }

  const hasErrors = () => {
    const selector = `applet_${pluralizeStepType(step.type)}/${
      step.indexByType
    }`
    const selectedError = errors.select(selector)
    return Object.keys(selectedError.all).length ? "dirty" : "valid"
  }

  return (
    <>
      {!step.collapsed ? (
        <>
          <TandaEditor
            contextChannelId={contextChannelId}
            serviceTandaDetails={
              step.channel_module_name
                ? availableTandas[step.channel_module_name]
                : {
                    module_name: "",
                    name: `Select a${step.type === "action" ? "n " : " "}${
                      step.type
                    }`,
                  }
            }
            allStepsOfType={availableTandas[pluralizeStepType(step.type)]}
            alreadySelectedTandas={alreadySelectedTandas}
            tanda={step}
            appletPublished={published}
            errors={errors}
            onRemoveTanda={onStepRemove}
            handleTandaSelect={onSelectStep}
            onUpdateFields={onUpdateField}
            newConfigMode
            last={true}
            onSaveTanda={saveAndClose}
          />
        </>
      ) : (
        <CollapsedConfigItem
          type={step.type}
          status={hasErrors()}
          title={step.name}
          index={oneBasedIndex}
          onUpdateViewClick={() => onChangeCollapse(step.type, false)}
          onRemoveClick={onStepRemove}
        />
      )}
    </>
  )
}

export default StepConfig
